import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory, DefaultContainerProps } from 'app/infrastructure/redux';
import { ListWrapper } from './components/list-wrapper';
import { ListRenderer } from './components/list-renderer';
import { actionCreators } from './actions';
import { externalUrlAdminTranslation } from '../constants';
import { ExternalUrlAdminState } from '../types-store';
import { scrollToTop } from 'app/infrastructure/platform/routing';

export type ExternalUrlsAdminListProps = DefaultContainerProps
  & ExternalUrlAdminState
  & typeof actionCreators;

class ExternalUrlsAdminListComponent extends React.PureComponent<ExternalUrlsAdminListProps> {
  public static statePath: string = STATE.externalUrlAdministration;

  public componentWillUnmount() {
    this.props.clearList();
  }

  public componentDidMount() {
    scrollToTop();
  }

  public render() {

    const { list, sharedState, translation,
      loadList, deleteExternalUrl, displayError } = this.props;

    return <ListWrapper
      displayError={displayError}
      sharedState={sharedState}
      translation={translation}>
      <ListRenderer
        listState={list}
        loadList={loadList}
        deleteExternalUrl={deleteExternalUrl}
        translation={translation}
      />
    </ListWrapper>;
  }
}

const container = containerFactory(ExternalUrlsAdminListComponent, actionCreators, undefined, externalUrlAdminTranslation);

export { container as ExternalUrlsAdminList };
